/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Col_MulticaInputs */

const en_mk_cmp_col_multica = /** @type {(inputs: Mk_Cmp_Col_MulticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multica`)
};

const id_mk_cmp_col_multica = /** @type {(inputs: Mk_Cmp_Col_MulticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multica`)
};

/**
* | output |
* | --- |
* | "Multica" |
*
* @param {Mk_Cmp_Col_MulticaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_col_multica = /** @type {((inputs?: Mk_Cmp_Col_MulticaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Col_MulticaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_col_multica(inputs)
	return en_mk_cmp_col_multica(inputs)
});